// extracted by mini-css-extract-plugin
export default {"form":"MessageForm_form__L8PM-","submit":"MessageForm_submit__ftBwi"};